export default __webpack_public_path__ + "static/media/banner.49f75a5d.jpeg";